/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_DescriptionInputs */



/**
* | output |
* | --- |
* | "Chainspect is Web3’s top blockchain fundamentals tracker, providing real-time analytics for investors, researchers, and builders. No paywalls, just data." |
*
* @param {Seo_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const seo_description = /** @type {((inputs?: Seo_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Chainspect is Web3’s top blockchain fundamentals tracker, providing real-time analytics for investors, researchers, and builders. No paywalls, just data.")
});